import '../Scss/main.scss';
import './components/shoelaceSetup';
import {initAri} from './components/ari';
import {initMobileNav} from './components/mobileNav';
import {initFlyoutDesktopMenu} from './components/flyoutDesktopMenu';
import {initFlyoutScroll} from './components/flyoutScroll';
import {initNavigationActiveState} from './components/navigationActiveState';
import {initBreadcrumb} from './components/breadcrumb';
import {initFlatpickr} from './components/flatpickr';
import {initTomSelect} from './components/tomSelect';
import {initAriImages} from '../Fusion/Component/Atom/Asset/AriImage/AriImage';
import {initNewsSlider} from './components/newsSlider';
import {initEventsSlider} from './components/eventsSlider';
import {initBabySlider} from './components/babySlider';
import {initImageCardSlider} from './components/imageCardSlider';
import {initImageTextCardSlider} from './components/imageTextCardSlider';
import {initImageSlider} from './components/imageSlider';
import {initVideoSlider} from './components/videoSlider';
import {initYouTubePlayer} from './components/youTubePlayer';
import {initEventCategoryFilter} from './components/eventCategoryFilter';
import {initAccordion} from './components/accordion';
import {initClinicSubnav} from './components/clinicSubnav';
import {initInputModality} from './components/inputModality';
import {initFormSubmitValidation} from './components/formSubmitValidation';
import {initRecaptchaV2} from './components/recaptchaV2';
import {initLanguageSwitcher} from './components/languageSwitcher';
import {initPersonFilter} from './components/personFilter';
import {initSearch} from './components/search';
import {initCookieBanner, markCookieConsentState} from './components/cookieBanner';

document.documentElement.classList.add('js');
markCookieConsentState();
initInputModality();

document.addEventListener('DOMContentLoaded', () => {
  initAriImages({
      imgProviderUrl: '/_ari/{identifier}/{hash}/{width}/{height}/{processing}/{filename}'
    },
    initAri
  );
  initMobileNav();
  initFlyoutDesktopMenu();
  initFlyoutScroll();
  initNavigationActiveState();
  initBreadcrumb();
  initFlatpickr();
  initTomSelect();
  initNewsSlider();
  initEventsSlider();
  initBabySlider();
  initImageCardSlider();
  initImageTextCardSlider();
  initImageSlider();
  initYouTubePlayer();
  initVideoSlider();
  initEventCategoryFilter();
  initAccordion();
  initClinicSubnav();
  initFormSubmitValidation();
  initRecaptchaV2();
  initLanguageSwitcher();
  initPersonFilter();
  initSearch();
  initCookieBanner();
});
